import req from '@/api/utilities/axios';

export enum ConfigKeys {
  mail_host = 'mail_host',
  mail_port = 'mail_port',
  mail_username = 'mail_username',
  mail_password = 'mail_password',
  mail_from_address = 'mail_from_address',
  mail_encryption = 'mail_encryption',
  mail_from_name = 'mail_from_name',
  mail_signature = 'mail_signature',
  mail_headline = 'mail_headline',
  mail_footer = 'mail_footer',
}

type AppConfigResource = {
  key: ConfigKeys;
  value: string | null;
}


export const getAppConfig = (): Promise<AppConfigResource[]> => {
  return req.get(`configs`).then(data => data.data.data);
};

export type CreateUpdateAppConfig = AppConfigResource[]
export const createUpdateAppConfig = (data: CreateUpdateAppConfig): Promise<AppConfigResource[]> => {
  return req.post(`configs`, data).then(data => data.data.data);
};

export const testMailConfigApi = (email: string): Promise<AppConfigResource[]> => {
  return req.post(`configs/test-mail`, {email}).then(data => data.data.data);
};
